import React from "react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router";
import * as Sentry from "@sentry/react";

Sentry.init({
  enabled: __APP_ENV__ === "production" || __APP_ENV__ === "staging",
  environment: __APP_ENV__,
  release: __APP_GIT_COMMIT_SHA__,

  dsn: "https://a68c0317e6a382daee5d1c89c7d5a9e4@o4510242240462848.ingest.us.sentry.io/4510242249506816",

  integrations: [
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  tracesSampleRate: 0.1,
  tracePropagationTargets: [
    /^\//,
    /^https:\/\/api(?:-staging)?\.rndcatalyst\.com/,
  ],

  sendDefaultPii: true,
});
